module.exports = __webpack_public_path__ + "static/media/logo_refine.18bb6541.png";